import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';
import './CmsQuote.css';
import { CmsMeta } from '../cmsMeta';

type CmsQuoteProps = {
	image: string;
	content: string;
	link_cta?: string;
	color?: string;
	source?: string;
};

export const CmsQuote = ({ image, content, link_cta, color = 'green', source }: CmsQuoteProps): JSX.Element => {
	const quote = (
		<section className={`cms-quote`}>
			{image && (
				<div className="cms-quote__image">
					<img src={image} alt={'quote image'} />
				</div>
			)}
			<div className="cms-quote__body" style={{ ['background-color' as string]: color }}>
				{content && <SanitizedHtml html={content} className="cms-quote__content" />}
			</div>
		</section>
	);

	return (
		<div className="cms-quote-wrapper">
			{link_cta ? (
				<a className="cms-quote__link" href={link_cta}>
					{quote}
				</a>
			) : (
				quote
			)}
			{source && <p className="cms-quote__source">{source}</p>}
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		"A picture beside a quote on a coloured background, for a customer's or a brand's own words. `content` takes simple html; `color` is the background, best one of the site's light colours such as #e4fbe7; `source` is a line under it saying who said it; `link_cta` makes the whole quote a link.",
	example: [
		'CmsQuote',
		{
			image: 'https://cdn.ondio.com/assets/66f6fc228135451180b52aea78ca046e.jpg',
			color: '#e4fbe7',
			content:
				'<p>”Med Leitz Ergo blir det enklare att skapa en arbetsplats som känns bra – hemma, på kontoret och överallt däremellan.”</p>',
			source: 'Leitz',
			link_cta: '',
		},
	],
};
